/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import2 from '../../buttons/icon-button/icon-button.component';
import * as import3 from 'ng2-translate/src/translate.pipe';
import * as import4 from 'ng2-translate/src/translate.service';
import * as import5 from '@angular/common';
import * as import6 from './quantity-control.component';
import * as import7 from '../../orchestration/session.model';
const styles_QuantityControlComponent:any[] = ([] as any[]);
export const RenderType_QuantityControlComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_QuantityControlComponent,
  data: {}
}
);
function View_QuantityControlComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.decrement()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      unavailable: [
        2,
        'unavailable'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.DECREMENT;
    const currVal_4:any = (co.decrementDisabled || (co.quantity <= co.minQuantity));
    const currVal_5:any = co.decrementUnavailable;
    ck(v,1,0,currVal_3,currVal_4,currVal_5);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_QuantityControlComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'quantity-field-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.label.common.qty'));
    ck(v,1,0,currVal_0);
  });
}
function View_QuantityControlComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.increment()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      unavailable: [
        2,
        'unavailable'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.INCREMENT;
    const currVal_4:any = (co.incrementDisabled || (co.quantity >= co.maxQuantity));
    const currVal_5:any = co.incrementUnavailable;
    ck(v,1,0,currVal_3,currVal_4,currVal_5);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export function View_QuantityControlComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'quantity-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'square',
      'rounded',
      'oval',
      'transparent'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_QuantityControlComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_QuantityControlComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'quantity-field-value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_QuantityControlComponent_3)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.QuantityControlComponent = v.component;
    const currVal_0:any = 'quantity-field';
    const currVal_1:any = ck(v,2,0,(co.sessionModel.currentApp.firstTierButtonShape === co.ButtonShape.SQUARE),(co.sessionModel.currentApp.firstTierButtonShape === co.ButtonShape.ROUNDED),(co.sessionModel.currentApp.firstTierButtonShape === co.ButtonShape.OVAL),co.transparent);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !co.readOnly;
    ck(v,5,0,currVal_2);
    const currVal_3:any = co.readOnly;
    ck(v,8,0,currVal_3);
    const currVal_5:boolean = !co.readOnly;
    ck(v,14,0,currVal_5);
  },(ck,v) => {
    var co:import6.QuantityControlComponent = v.component;
    const currVal_4:any = co.quantity;
    ck(v,11,0,currVal_4);
  });
}
function View_QuantityControlComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-quantity-control',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).onClick($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_QuantityControlComponent_0,RenderType_QuantityControlComponent)),
    import0.ɵdid(49152,(null as any),0,import6.QuantityControlComponent,[import7.SessionModel],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const QuantityControlComponentNgFactory:import0.ComponentFactory<import6.QuantityControlComponent> = import0.ɵccf('woa-quantity-control',import6.QuantityControlComponent,View_QuantityControlComponent_Host_0,{
  decrementUnavailable: 'decrementUnavailable',
  incrementUnavailable: 'incrementUnavailable',
  decrementDisabled: 'decrementDisabled',
  incrementDisabled: 'incrementDisabled',
  minQuantity: 'minQuantity',
  maxQuantity: 'maxQuantity',
  quantity: 'quantity',
  transparent: 'transparent',
  readOnly: 'readOnly'
}
,{
  onDecrement: 'onDecrement',
  onIncrement: 'onIncrement'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/inputs/quantity-control/quantity-control.component.ngfactory.ts